<template>
  <div>
    <nav-bar></nav-bar>
    <div
        class="container-fluid has-action-bar bg-music pt-16">
      <div class="container pt-16">
        <div class="row">
          <div class="col-12 text-center">
            <h3 class="font20px d-block secondary-text">{{ $getText("CONTACT_US_HEADER") }}</h3>
            <p class="gray-text font14px d-block">{{ $getText("CONTACT-US-HEADER-SECOND") }}</p>
          </div>

          <div class="col-md-3 align-items-center justify-content-center mx-auto">
            <div class="text-center py-3">
              <i class="fa-solid fa-phone-office font-40"></i>
              <span class="d-block font12px gray-text pt-5 pb-5">{{ $getText("PHONE") }} :</span>
              <a class=" d-block" href="tel:021-77185677">{{ $getText("PHONE-NUM1") }}</a>
              <a class=" d-block" href="tel:021-77202347">{{ $getText("PHONE-NUM2") }}</a>
            </div>
          </div>
          <div class="col-md-3 align-items-center justify-content-center mx-auto">
            <div class="text-center py-3">
              <i class="fa-solid fa-mobile font-40"></i>
              <span class="d-block font12px gray-text pt-5 pb-5">
                            {{ $getText("MOBILE") }} :
                        </span>
              <a class=" d-block" href="tel:09126483554">{{ $getText("MOBILE-NUM1") }}</a>
              <a class=" d-block" href="tel:09126770412">{{ $getText("MOBILE-NUM2") }}</a>
            </div>
          </div>
          <div class="col-md-3 align-items-center justify-content-center mx-auto">
            <div class="text-center py-3">
              <i class="fa-solid fa-location-dot font-40"></i>
              <span class="d-block font12px gray-text pt-5 pb-5 ">
                            {{ $getText("ADDRESS-TITLE") }} :
                        </span>
              <span class=" d-block secondary-text">
                            {{ $getText("ADDRESS") }}
                        </span>
            </div>
          </div>
          <div class="col-md-3 align-items-center justify-content-center mx-auto">
            <div class="text-center py-3">
              <i class="fa-solid fa-envelope font-40"></i>
              <span class="d-block font12px gray-text pt-5 pb-5">
                            {{ $getText("EMAIL") }} :
                        </span>
              <span class=" d-block secondary-text">
                            {{ $getText("EMAIL-TEXT") }}
                        </span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <GmapMap
                ref="mapRef"
                :center="myCoordinates"
                :options='{ fullscreenControl: false, mapTypeControl: false }'
                :zoom="zoom"
                style="height:360px"
            >
              <GmapMarker
                  v-for='(marker,index) in markers'
                  :key="index"
                  :animation="2"
                  :clickable="true"
                  :position="marker"
                  @click="center=marker"/>
            </GmapMap>
          </div>
          <div class="col-12">
            <h3 class="text-center secondary-text h5">لینک های مسیریابی</h3>
            <div class="row">
              <div class="col-3 text-center">
                <a :href="'https://www.google.com/maps/dir///'
                  + myCoordinates.lat + ',' + myCoordinates.lng"
                   target="_blank">
                  <img alt="آدرس طراحی وب سایت اپلیکیشن موبایل و استارت اپ"
                       class="img-fluid"
                       src="../assets/img/directions/google.png"
                       title="آدرس طراحی وب سایت اپلیکیشن موبایل و استارت اپ"
                  />
                </a>
              </div>
              <div class="col-3 text-center">
                <a :href="'https://waze.com/ul?ll='
                  + myCoordinates.lat + ',' + myCoordinates.lng"
                   target="_blank">
                  <img alt="آدرس طراحی وب سایت اپلیکیشن موبایل و استارت اپ" class="img-fluid"
                       src="../assets/img/directions/waze.png"
                       title="آدرس طراحی وب سایت اپلیکیشن موبایل و استارت اپ"
                  />
                </a>
              </div>
              <div class="col-3 text-center">
                <a :href="'https://neshan.org/maps/routing/car/destination/'
                  + myCoordinates.lat + ',' + myCoordinates.lng"
                   target="_blank">
                  <img alt="آدرس طراحی وب سایت اپلیکیشن موبایل و استارت اپ" class="img-fluid"
                       src="../assets/img/directions/neshan.png"
                       title="آدرس طراحی وب سایت اپلیکیشن موبایل و استارت اپ"
                  />
                </a>
              </div>
              <div class="col-3 text-center">
                <a :href="'https://balad.ir/directions/driving?destination='
                  + myCoordinates.lng + ',' + myCoordinates.lat"
                   target="_blank">
                  <img alt="آدرس طراحی وب سایت اپلیکیشن موبایل و استارت اپ" class="img-fluid"
                       src="../assets/img/directions/balad.png"
                       title="آدرس طراحی وب سایت اپلیکیشن موبایل و استارت اپ"
                  />
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
    <footer-pages></footer-pages>
  </div>
</template>

<script>


import NavBar from "@/components/NavBar";
import FooterPages from "@/components/FooterPages";

export default {
  name: "ContactUs",
  metaInfo: {
    title: 'ایزیسیس طراحی وب سایت اپلیکیشن موبایل و استارت اپ-تماس با ما'
  },
  components: {FooterPages, NavBar},
  data: () => ({
    title: "تماس با ما",
    myCoordinates: {
      lat: 35.73429238394536,
      lng: 51.487861978095005
    },
    center: {
      lat: 35.73429238394536,
      lng: 51.487861978095005
    },
    zoom: 16,
    markers: [
      {
        lat: 35.73429238394536,
        lng: 51.487861978095005
      }
    ],

  }),
  methods: {
    getImgUrl(pic) {
      return require('../assets/img/' + pic)
    },
  },
  mounted() {
    this.isokia = this.$getisokia();
    this.$setCssFiles();
  },
}
</script>

<style scoped>

</style>
